import type { FC } from "react";
import { useMemo } from "react";
import type { ISegmentFilterListItem } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { ListItemKeyword } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import noop from "lodash/noop";
import {
    ListItemKeywordWrapper,
    ListItemKeywordWrapperStyled,
    TooltipWrapper,
} from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/segmentRulesStyles";
import { StyledIcon } from "app/pages/segments/redesigned-wizard/segment-wizard/styledComponents";
import { FILTERS_OBJECT } from "app/pages/segments/redesigned-wizard/segment-wizard/constants";

export const SegmentFilterListItem: FC<ISegmentFilterListItem> = (props) => {
    const {
        childKey,
        iconName,
        textKey,
        onClick,
        tooltipKey,
        hideUrlsPreview,
        isSelectedValue,
        filterKey,
        tooltipTextI18nProp,
        isLocked,
    } = props;
    const shouldDisableFolders = useMemo(
        () => hideUrlsPreview && filterKey === FILTERS_OBJECT.FOLDERS.filterKey,
        [filterKey, hideUrlsPreview],
    );

    const iconNameProp = isLocked ? "locked" : iconName;

    return (
        <ListItemKeywordWrapper isSelectedValue={isSelectedValue}>
            <PlainTooltip
                tooltipContent={i18nFilter()(tooltipKey, { siteName: tooltipTextI18nProp })}
                placement="right"
            >
                <TooltipWrapper
                    isSelectedValue={isSelectedValue}
                    disabledItemColor={shouldDisableFolders}
                    isLocked={isLocked}
                >
                    <ListItemKeywordWrapperStyled isLocked={isLocked}>
                        <ListItemKeyword
                            key={childKey}
                            iconName={iconNameProp}
                            text={i18nFilter()(textKey)}
                            onClick={shouldDisableFolders ? noop : onClick}
                        />
                    </ListItemKeywordWrapperStyled>
                    {isLocked && (
                        <StyledIcon
                            isLocked={isLocked}
                            className="list-item-icon"
                            iconName="arrow-right"
                            size="sm"
                            isListItemIcon={true}
                        />
                    )}
                </TooltipWrapper>
            </PlainTooltip>
        </ListItemKeywordWrapper>
    );
};
